/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ group: NonNullable<unknown> }} Users_Admin_HintInputs */

const en_users_admin_hint = /** @type {(inputs: Users_Admin_HintInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`You are signed in as a member of the ${i?.group} group.`)
};

const pt_br2_users_admin_hint = /** @type {(inputs: Users_Admin_HintInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Você está conectado como membro do grupo ${i?.group}.`)
};

/**
* | output |
* | --- |
* | "You are signed in as a member of the {group} group." |
*
* @param {Users_Admin_HintInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const users_admin_hint = /** @type {((inputs: Users_Admin_HintInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Users_Admin_HintInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_users_admin_hint(inputs)
	return pt_br2_users_admin_hint(inputs)
});